import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserService } from "../../services/User.service";
import "./style/RegisterPage.css"; // Importa el archivo CSS
import { loginRequest } from "../../@types/Login";

const RegisterPage: React.FC = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
    mail: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [usuarioExistente, setUsuarioExistente] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));

    if (id === "mail") {
      const userResponse = await UserService.getUser(value);

      if (userResponse[0] != "") setUsuarioExistente("El email ingresado ya está registrado.");
      else setUsuarioExistente("");
    }
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const { username, password, confirmPassword, mail } = formData;

    if (!username || !mail || !password) {
      setError("Los campos Usuario, Correo y Contraseña son obligatorios.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(mail)) {
      setError("El correo electrónico no es válido.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    if (usuarioExistente !== "") {
      setError(usuarioExistente);
      return;
    }

    try {
      setLoading(true);
      const result = await UserService.registerUser(formData as loginRequest);
      setSuccess(result.message);
      setTimeout(() => navigate("/login"), 2000);
    } catch (error: unknown) {
      setError(error instanceof Error ? error.message : String(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="form-container">
        <h1 className="title">Registro de Usuario</h1>
        <form onSubmit={handleRegister} className="form">
          {[
            { id: "username", label: "Usuario", type: "text" },
            { id: "mail", label: "Correo Electrónico", type: "email" },
            { id: "password", label: "Contraseña", type: "password" },
            {
              id: "confirmPassword",
              label: "Confirmar Contraseña",
              type: "password",
            },
            { id: "firstName", label: "Nombre", type: "text" },
            { id: "lastName", label: "Apellido", type: "text" },
            { id: "phone", label: "Teléfono", type: "text" },
            { id: "address", label: "Dirección", type: "text" },
            { id: "city", label: "Ciudad", type: "text" },
            { id: "state", label: "Provincia/Estado", type: "text" },
            { id: "country", label: "País", type: "text" },
          ].map(({ id, label, type }) => (
            <div className="input-group" key={id}>
              <label htmlFor={id} className="label">
                {label}
              </label>
              <input
                id={id}
                type={type}
                value={(formData as any)[id]}
                onChange={handleInputChange}
                placeholder={`Ingresa ${label.toLowerCase()}`}
                className="input"
                required={["username", "mail", "password"].includes(id)}
              />
              {id === "mail" && (
                <p className="usuario-existente">{usuarioExistente}</p>
              )}
            </div>
          ))}
          {error && <p className="error">{error}</p>}
          {success && <p className="success">{success}</p>}
          <div className="button-group">
            <button
              type="submit"
              className="button button-primary"
              disabled={loading}
            >
              {loading ? "Registrando..." : "Registrar"}
            </button>
            <button
              type="button"
              className="button button-secondary"
              onClick={() => navigate("/login")}
            >
              Volver al inicio
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
